class TranslationProvider {
  constructor(translations = {}) {
    this.translations = translations
  }

  getTranslations() {
    return this.translations
  }

  setTranslations(newTranslations) {
    this.translations = { ...this.translations, ...newTranslations }
  }

  getTrans(id, def = null, params = {}, type = 'messages'){
    if(this.translations[type][id]){
      let trad = this.translations[type][id];
      for (const [key, param] of Object.entries(params)) {
        trad = trad.replace(key, param);
      }
      return trad;
    }

    if (def){
      return def
    }
    return id;
  }
}
let instance = null;
function getInstance() {
  if (!instance) {
    instance = new TranslationProvider()
  }
  return instance
}

export default getInstance()
